<template>
    <a
      class="nav-user"
      :href="accountProfileUrl">
      <SVGUser2/>
      <transition name="show-me">

      <div v-if="accountLoggedIn">
        <span>{{$t('loginwidget.profile')}}</span>
      </div>
      <div v-if="!accountLoggedIn && !accountLoading">
        <span>{{$t('loginwidget.login')}}</span>
      </div>
      </transition>

    </a>
</template>


<script>
  import {mapGetters} from "vuex"

  export default {
    computed: {
      ...mapGetters('account', [
        'accountLoggedIn',
        'accountProfileUrl',
        'accountLoading'
      ])
    },
    methods: {
      onCartClick() {
        if (this.hasCart) {
          this.$store.dispatch('redirectToExistingCart')
        }
      }
    }
  }
</script>

<style>

</style>
